import { FC, useCallback, useEffect, useState } from "react";
import Overlay from "./overlay";
import { parse, differenceInDays } from 'date-fns';
import {
  FiSearch,
  FiCopy,
  FiShare2,
  FiSend,
  FiMinusCircle,
} from "react-icons/fi";
import { BsQuestionCircle } from "react-icons/bs";
import ReferralItem from "./ReferralItem";
import "./profilepage.css";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "next-share";
import { Modal } from "react-bootstrap";
import { useDisclosure } from "./useDisclosure";
import { IUserDetails, Referrers, Referrals, Transactions, Tickets } from "./EnrollTypes";
import axios from "axios";
import {z, ZodType } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl, GetToken } from "../App";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  User: IUserDetails | undefined;
  Referrer: Referrers | undefined;
}

type FormData = {
  fullName: string;
  accountNumber?: string;
  bankName: string;
  BIC?: string;
  accountType?: string;
  routingNumber?: string;
  IBAN?: string;
};

type TicketData = {
  ticketTitle: string;
  ticketComplaint: string;
}
const ReferralPage: FC<Props> = ({
  isOpen,
  onClose,
  User,
  Referrer,
}) => {
  const [transactions, setTransactions] = useState<Transactions[]>(Referrer?.Transactions || []);
  const [isBlurred, setIsBlurred] = useState(true);
  const [Earnings, setEarnings] = useState("0");
  const [idToken, setIdToken] = useState();
  const [transactionId, setTransactionId] = useState("")
  const [accountNumber, setAccountNumber] = useState(Referrer?.Bank?.AccountNumber || "");
  const [fullName, setfullName] = useState(Referrer?.Bank?.AccountName || "");
  const [bankName, setBankName] = useState(Referrer?.Bank?.BankName || "");
  const [BIC, setBIC] = useState(Referrer?.Bank?.BankName || "");
  const [accountType, setAccountType] = useState(Referrer?.Bank?.AccountType || "");
  const [IBAN, setIBAN] = useState(Referrer?.Bank?.IBANNumber || "");
  const [routingNumber, setRoutingNumber] = useState(Referrer?.Bank?.RoutingABANumber || "");
  const [ReferrerCurrency, setReferrerCurrency] = useState(Referrer?.Bank?.CurrencySymbol || "NGN");
  const [amountWithdrawable, setAmountWithdrawable] = useState(0)
  const [count , setCount] = useState(0);
  const [ReferralRate, setReferralRate] = useState(0.1);
  const [ReferralWords, setReferralWords] = useState("10% (ten percent)");
  const [copied, setCopied] = useState(false);
  const [showReferrals, setShowReferrals] = useState(true);
  const [showWithdrawal, setShowWithdrawal] = useState(false);
  const [showAccountDetails, setShowAccountDetails] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [showRequest, setShowRequest] = useState(false);
  const [confirmRequest, setConfirmRequest] = useState(false);
  const [ticket, setTicket] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [inputs, setInputs] = useState([{ id: 1, value: "" }]);
  const [isHovered, setIsHovered] = useState(false);
  const [error, setError] = useState("");
  const { isOpen: Open, onClose: Close, onOpen: modalOpen } = useDisclosure();
  const addInputField = () => {
    setInputs([...inputs, { id: inputs.length + 1, value: "" }]);
  };
  const removeInputField = (id: any) => {
    setInputs((prevInputs) =>
       prevInputs.filter((input) => input.id !== id) 
    );
  };

  const handleInputChange = (id: any, value: any) => {
    const newInputs = inputs.map((input) =>
      input.id === id ? { ...input, value } : input
    );
    setInputs(newInputs);
  };
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const toggleBlur = () => {
    setIsBlurred(!isBlurred);
  };
  const handleCopy = () => {
    // Copy text to clipboard
    navigator.clipboard
      .writeText(`academy.doyenify.com/signup?invite=${User?.ReferralId}`)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
  };

  ///////CODE SECTIONS HERE
  const formatDate = (date: Date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${day}/${month}/${year}`;
  };

  const enableTicketOrNot = useCallback((date: string) => {
   const parsedDate = parse(date, "dd/MM/yyyy", new Date());
    const daysDifference = differenceInDays(new Date(), parsedDate);
    return daysDifference <= 2;
  },[]);


  const priceSplitter = (number: any) =>
    number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const CurrencyConvertion = useCallback(async (
    baseCurrency: string,
    expectedCurrency: string,
    baseValue: number
  ): Promise<number | null> => {
    return await axios
      .get(
        `https://v6.exchangerate-api.com/v6/64ffa46158cccca95fdfa2db/pair/${baseCurrency}/${expectedCurrency}/${baseValue}`
      )
      .then((expectedValue) => {
        if (expectedValue.data.result === "success") {
          return expectedValue.data?.conversion_result;
        }
        if (expectedValue.data.result === "error") {
          return null;
        }
      });
  },[]);

  const calculateEarnings = useCallback(async () => {
    let count = 0;
    if (count === 0) {
      let allReferrals: Referrals[] = [];
      Referrer?.Referrals.map((Referral) => {
        return allReferrals.push(Referral);
      });
      if (allReferrals.length > 0) {
        let earnings = 0;
        allReferrals.forEach(async (Referral: Referrals) => {
          let conversionResult = await CurrencyConvertion(
            Referral.CurrencyOfCoursePaidFor,
            "EUR",
            Referral.PriceOfCoursePaidFor * ReferralRate
          );
          if (conversionResult) {
            earnings += conversionResult;
            setEarnings(earnings.toFixed(2));
          }
        });
        //Patch Method
        if (idToken) {
          const body = {
            EarningsAccrued: Earnings,
          };
          axios.patch(
            `${baseUrl}/referrers/${Referrer?.Id}`,
            body,
            {
              headers: {
                Authorization: `Bearer ${idToken}`,
              },
            }
          );
        }
      }
  }
  }, [ReferralRate, Referrer?.Referrals, Earnings, Referrer?.Id, idToken, CurrencyConvertion]);

  const threshholdReached= ():boolean =>{
    if(Referrer?.Bank?.CurrencySymbol === "NGN" && amountWithdrawable > 10000){return false}
    if(Referrer?.Bank?.CurrencySymbol === "EUR" && amountWithdrawable > 10){return false}
    if(Referrer?.Bank?.CurrencySymbol === "USD" && amountWithdrawable > 10){return false}
    if(Referrer?.Bank?.CurrencySymbol === "GBP" && amountWithdrawable > 10){return false}
    return true;
  }

  const checkIfNotEmpty = () => {
    if(Referrer){
    if(fullName !== "" && bankName !== ""){
      setDisabled(false);
    }
    else{setDisabled(true)
    }}
  }

  ///PATCH DATA
  const RequestEarningsPayment = async () =>{
    if(Referrer)
    {
      try{
        const transactions: Transactions[] = Referrer?.Transactions || [];
        const body={
          EarningsPaid: Referrer?.EarningsPaid + Number(Earnings),
          Transactions:[
            ...transactions,
            {
              TransactionId: Referrer?.ReferrerId+ formatDate(new Date()),
              Amount: amountWithdrawable,
              TransactionCurrency: Referrer?.Bank?.CurrencySymbol,
              PaymentStatus: "Pending",
              InitiatedTime: formatDate(new Date()),
              ProcessedTime: ""
            }
          ]
        }
        await axios.patch(
          `${baseUrl}/referrers/${Referrer?.Id}`, body,
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          }
        );
        setShowRequest(true);
        setEarnings((0).toFixed(2));
        setAmountWithdrawable(0);
        setCount(1);
        reloadData();
      }catch(error:any){
        console.log("Could not send transaction request.");
        console.log(error.message);
      }
    }
  }

  const reloadData = useCallback(async ()=>{
    try{
      if(Referrer){
    const referrerData = await axios.get(
      `${baseUrl}/referrers/${Referrer?.Id}`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );
    const sortedTransactions = referrerData?.data?.data?.Transactions?.sort((a:any, b:any) => {
      const dateA:any = parse(a.InitiatedTime, 'dd/MM/yyyy', new Date());
      const dateB:any = parse(b.InitiatedTime, 'dd/MM/yyyy', new Date());
      return dateB - dateA;
    });
    
    setTransactions(sortedTransactions)}
  }catch(error:any){
    console.log(error.message);
    console.log("Could not fetch Transactions");
  }
  },[idToken, Referrer])


  const createTicket = async (data: TicketData) => {
    try{
      const tickets:Tickets[] = Referrer?.Tickets || [];
      const body={
        Tickets:[
          ...tickets,
          {
            //TransactionId: Referrer?.ReferrerId+ formatDate(new Date()),
            Title: data.ticketTitle,
            Message: data.ticketComplaint,
            TransactionId: transactionId,
            DateOpened: formatDate(new Date()),
            Status: "Pending", // or resolved.
            DateClosed: ""
          }
        ]
      }
      await axios.patch(
        `${baseUrl}/referrers/${Referrer?.Id}`, body,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      toast("Ticket submitted successfully.");
      handleCloseTicket();
    }catch(error:any){
      console.log("Could not send ticket to db.");
      console.log(error.message);
    }
  }

  const submitData = async (data: FormData) => {
    let body = {};
    if(ReferrerCurrency === 'USD'){
      body = {
        Bank:{
        AccountName: data?.fullName,
        BankName: data?.bankName,
        AccountNumber: data?.accountNumber,
        CurrencySymbol: ReferrerCurrency,
        AccountType: data?.accountType,
        RoutingABANumber: data?.routingNumber,
        }
      }
    }
    if(ReferrerCurrency === 'EUR'){
      body ={
        Bank:{
        AccountName: data?.fullName,
        CurrencySymbol: ReferrerCurrency,
        BankName: data?.bankName,
        IBANNumber: data?.IBAN,
        BIC: data?.BIC,
        }
      }
    }
    if(ReferrerCurrency === 'NGN'){
      body ={
        Bank:{
        AccountName: data?.fullName,
        CurrencySymbol: ReferrerCurrency,
        AccountNumber: data?.accountNumber,
        BankName: data?.bankName,
        }
    }
  }
    if(ReferrerCurrency === 'GBP'){
      body ={
        Bank:{
        AccountName: data?.fullName,
        CurrencySymbol: ReferrerCurrency,
        AccountNumber: data?.accountNumber,
        BankName: data?.bankName,
        IBANNumber: data?.IBAN,
        }
    }
    }
    try{
      if(Referrer)
      {
        await axios.patch(
          `${baseUrl}/referrers/${Referrer?.Id}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          }
        );
      }
      toast("Account details saved successfully");
      setDisabled(true);
    }catch(error:any){
      console.log(error.message)
    }
  };

  useEffect(() => {
    if (Referrer?.Bank) {
      setAccountNumber(Referrer.Bank.AccountNumber);
      setBankName(Referrer.Bank?.BankName);
      setfullName(Referrer.Bank?.AccountName);
      setBIC(Referrer.Bank?.BIC);
      setRoutingNumber(Referrer.Bank?.RoutingABANumber);
      setIBAN(Referrer.Bank?.IBANNumber);
      setAccountType(Referrer.Bank?.AccountType);
    }
    if (Referrer?.Bank?.CurrencySymbol) {
      setReferrerCurrency(Referrer.Bank.CurrencySymbol);
    }
    const fetchId = async () => {
      const id_Token = await GetToken();
      setIdToken(id_Token)
        if(Referrer?.EarningsAccrued === 0){
          const amount_withdrawable = await CurrencyConvertion(
            Referrer?.EarningsCurrency,
            Referrer?.Bank?.CurrencySymbol,
            Number(Earnings)
          );
          if(amount_withdrawable)
          {
            if(ReferrerCurrency === "NGN")
            {
              if(amount_withdrawable < 100){setAmountWithdrawable(Math.floor(amount_withdrawable))}
              else{setAmountWithdrawable(Math.floor(amount_withdrawable / 100) * 100)}
            }
            else{setAmountWithdrawable(Math.floor(amount_withdrawable / 10) * 10)}
          }
        }
    };
    if (Referrer?.ReferrerStatus === "Employee" || Referrer?.ReferrerStatus === "Admin") {
      setReferralRate(0.15);
      setReferralWords("15% (fifteen percent)");
    }
    if(Referrer){
    if (!Referrer?.EarningsAccrued){
      calculateEarnings();
    }else{
      if(count === 0){
      setEarnings(Math.max(0, (Referrer?.EarningsAccrued - Referrer?.EarningsPaid)).toFixed(2));
      }
    }
  }
    fetchId();
    reloadData();
  }, [Referrer?.ReferrerStatus, count, reloadData, Earnings, Referrer, calculateEarnings, Referrer?.Bank, Referrer?.EarningsCurrency, ReferrerCurrency, CurrencyConvertion]);





  /////////
  const Referrals = () => {
    setShowReferrals(true);
    setShowAccountDetails(false);
    setShowWithdrawal(false);
  };

  const AccountDetails = () => {
    setShowReferrals(false);
    setShowAccountDetails(true);
    setShowWithdrawal(false);
  };

  const Withdrawal = () => {
    setShowReferrals(false);
    setShowAccountDetails(false);
    setShowWithdrawal(true);
  };
  const handleRequestClose = () => {
    setConfirmRequest(false);
  };
  const handleCloseRequest = () => {
    setShowRequest(false);
  };
  const handleCloseTicket = () => {
    setTicket(false);
  };
  const nameRegex = /^[A-Za-z\s]+$/;
  const numberRegex = /^[0-9]+$/;
  const schema: ZodType<FormData> = z.object({
    fullName: z
      .string()
      .min(5, { message: "Fullname must be at least 5 characters long" })
      .max(30, { message: "Fullname must be at most 30 characters long" })
      .regex(nameRegex, {
        message: "Fullname must only contain alphabetic characters",
      }).refine((value) => {
        let UserFullName = User?.firstname + " " + User?.lastname;
        const userFullNameWords = UserFullName.toLowerCase().split(' ');
        const inputNameWords = value.toLowerCase().split(' ');
      
        const matchCount = inputNameWords.filter((word) =>
          userFullNameWords.includes(word)
        ).length;
        return matchCount >= 2;
      }, {
        message: 'Account name must contain at least two words from your registered full name',
      }),
    accountNumber: z
      .string()
      .min(5, { message: "Account number must be at least 5 characters long" })
      .max(15, { message: "Account number must be at most 15 characters long"})
      .regex(numberRegex, {
        message: "Account number must only contain numbers",
      }).optional(),
    routingNumber: z
      .string()
      .min(5, { message: "Routing number must be at least 5 characters long" })
      .max(15, { message: "Routing number must be at most 15 characters long"})
      .regex(numberRegex, {
        message: "Account number must only contain numbers",
      }).optional(),
      accountType: z
      .string()
      .min(5, { message: "Account Type must be at least 2 characters long" })
      .max(20, { message: "Account Type must be at most 20 characters long"})
      .optional(),
      BIC: z
      .string()
      .min(5, { message: "BIC must be at least 3 characters long" })
      .max(20, { message: "BIC must be at most 20 characters long"})
      .optional(),
      IBAN: z
      .string()
      .min(5, { message: "IBAN must be at least 3 characters long" })
      .max(30, { message: "IBAN must be at most 30 characters long"})
      .optional(),
    bankName: z
      .string()
      .min(2, { message: "Bank name must be at least 2 characters long" })
      .max(40, { message: "Bank name must be at most 40 characters long" })
      .regex(nameRegex, {
        message: "Bank name must only contain alphabetic characters",
      }),
  });

  const ticketSchema: ZodType<TicketData> = z.object({
    ticketTitle: z
    .string()
    .min(10, { message: "Title should be at least 10 characters long" })
    .max(50,{ message: "Title should be at most 50 characters long" })
    .regex(nameRegex, {
      message: "Title must only contain alphabetic characters",
    }),
    ticketComplaint: z
    .string()
    .min(20, { message: "Compaint message should be at least 20 characters long" })
    .max(250, { message: "Compaint message should be at most 250 characters or 50 words long"}),
  });

  const {
    register: saveAccountDetails,
    handleSubmit: handleSubmit1,
    formState: { errors: accountErrors},
  } = useForm<FormData>({ resolver: zodResolver(schema)});

  const {
    register: saveTicketDetails,
    handleSubmit: handleSubmit2,
    formState: { errors : ticketErrors },
  } = useForm<TicketData>({ resolver: zodResolver(ticketSchema)});


  const sendEmail = async () => {
    try {
      for (const input of inputs) {
        const email = input.value;
        if (email === "") {
          setError("Please enter email");
          setTimeout(() => {
            setError("");
          }, 2000);
        } else {
          const bodytouser = {
            sender: {
              name: User?.firstname + " " + User?.lastname,
              email: User?.email,
            },
            to: [
              {
                email: email,
              },
            ],
            replyTo:{
              email:"info.doyenify@gmail.com",
            },
            subject: "Invitation Link",
              htmlContent: `<html><head></head><body>
                                        <p>Doyenify academy is an online tech school for learning cutting edge digital skills.</p>
                                      <p>Join the academy with my invite link: {{params.link}}</p>
                                  </body></html>`,
            params: {
              link: `academy.doyenify.com/signup?invite=${User?.ReferralId}`,
            },
          };
          // Send email to user

           const response = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
              process.env.REACT_APP_SERVICE_KEY, {
              method: "post",
              body: JSON.stringify({
                email: process.env.REACT_APP_SERVICE_EMAIL,
                password: process.env.REACT_APP_SERVICE_PASSWORD,
                returnSecureToken: true,
              }),
              headers: {
                "Content-Type": "application/json",
              },
            });
    
            const userToken = await response.json();
            await axios
            .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
                headers: { Authorization: `Bearer ${userToken.idToken}` },
              }
            )
            .then()
            .catch(() => {
              console.log("(axios) an error occurred")
            });
        
          toast("Emails sent successfully!");
          setInputs([{ id: 1, value: "" }]);
        }
      }
    } catch (error) {
      console.error("Error sending emails:", error);
      alert("Failed to send emails.");
    }
  };
  if (!isOpen) return null;

  return (
    <Overlay isOpen={isOpen} onClose={onClose}>
      <ToastContainer autoClose={2000} />
      <Overlay isOpen={Open} onClose={Close}>
        <div className="py-3 text-justify">
          <p className="max-w-96">
            The Doyenify Academy Referral program provides the avenue for our
            doyens to not only gain vast understanding in their chosen career
            through our services, but to also earn as they invite others to
            learn.
            <p />
            <p className="font-semibold">Earnings: </p>
            <p className="max-w-96">
              The earning is calculated as {ReferralWords} of the price of the
              course your referral enrols for. There is no limit to how much you
              can earn through this referral program as long as you keep
              inviting people to enroll for courses.
            </p>
            <p className="max-w-96">
              You are also eligible to earn multiple times from inviting a
              single individual, as long as the individual continues to enroll
              for courses.
            </p>
          </p>
          <p className="max-w-96">
            Your earning is displayed in Euros, but you can withdraw in four
            currencies: Naira, Euros, Pounds or US dollars. On the
            'Account Details' page, you can choose the currency local to your
            bank account as well as your bank account details.
          </p>
          <p className="max-w-96">
            Your referral link is a unique one that is automatically generated
            once a user signs up. Your first name is the prefix of the invite
            code. This is to familiarize your potential referrals with the
            authenticity of the url. You can also share invites to as many as
            possible via email.
          </p>
          <p className="max-w-96">
            Your earning is automatically re-calculated and updated once one of
            your referrals makes a payment for a service or course. The payment
            status of your referrals are also displayed on the page for you to
            calculate your earnings should you want to.{" "}
          </p>
          <p className="font-semibold">Withdrawal and Transactions:</p>
          <p className="max-w-96">
            You can only input your bank details if you have referred at least
            one person, regardless of their payment status. The dropdown for currencies
            gives you a choice of currencies to choose from which determines the required
            payment details as well.</p>
            <p className="max-w-96">
            You can place a withdrawal request at any time with a minimum
            earnings of $10, £10, €10, or N10,000 depending on your fiat currency.{" "}
          </p>
          <p className="max-w-96">
            The transaction history displays the amount requested for, the
            request status as well as provide the chance to open a complaint
            ticket should any issues arise.
          </p>
          <p className="max-w-96">
            We'd like to inform you that a typical transaction period
            (i.e withdrawal to being credited) might take up to three (3)
            business days. The 'Open Ticket' button will automatically be
            enabled for you to make a transaction complaint.
          </p>
          <p className="max-w-96">
            Thank you for being our referrer. Doyenify acknowledges and
            appreciate you. We look forward to working more with you.{" "}
          </p>
        </div>
      </Overlay>
      <Modal show={ticket} centered={true}>
        <Modal.Body>
          <div
            className="flex justify-end cursor-pointer px-3 py-1"
            onClick={handleCloseTicket}
          >
            <p>X</p>
          </div>
          <form onSubmit={handleSubmit2(createTicket)}>
            <div className="text-center py-3 px-4">
              <div className="flex items-center py-3">
                <label htmlFor="title" className="w-1/4 text-left">
                  Title:
                </label>
                <input
                  type="text"
                  placeholder="Enter Title"
                  className="flex-1 p-2 ml-4 border rounded-lg border-[#D2D2D2]"
                  {...saveTicketDetails("ticketTitle")}
                />
              </div>
              {ticketErrors.ticketTitle && (
                  <p className="errortext">{ticketErrors.ticketTitle.message}</p>
                )}


              <div className="flex items-center py-3">
                <label htmlFor="complaint" className="w-1/4 text-left">
                  Complaint:
                </label>
                <textarea
                  id="complaint"
                  placeholder="Explain briefly here..."
                  cols={10}
                  className="flex-1 p-2 ml-4 border rounded-lg border-[#D2D2D2]"
                  {...saveTicketDetails("ticketComplaint")}
                ></textarea>
              </div>
              {ticketErrors.ticketComplaint && (
                  <p className="errortext">{ticketErrors.ticketComplaint.message}</p>
                )}
              <button
                type="submit"
                className="btn btn-success mt-4"
              >
                Submit
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal show={showRequest} centered={true}>
        <Modal.Body>
          <div
            className="flex justify-end cursor-pointer px-3 py-1"
            onClick={handleCloseRequest}
          >
            <p>X</p>
          </div>
          <div className="text-center py-3">
            <h2 className="font-semibold">Request Successful!</h2>
            <p>Withdrawal request has been submitted successfully. Your payment will soon be processed. Thank you!</p>
            <button className="btn btn-success" onClick={handleCloseRequest}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={confirmRequest} centered={true}>
        <Modal.Body>
          <div
            className="flex justify-end cursor-pointer px-3 py-1"
            onClick={handleRequestClose}
          >
            <p>X</p>
          </div>
          <div className=" p-3">
            <h2 className="font-semibold text-center">{Referrer?.Bank?.CurrencySymbol + " " + priceSplitter(amountWithdrawable)}</h2>
            <div className="flex justify-between">
              <p className="text-[#9D9D9D]">Bank</p>
              <p className="flex items-center gap-3">
                {Referrer?.Bank?.BankName}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-[#9D9D9D]">Account Number</p>
              <p>{Referrer?.Bank?.AccountNumber}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-[#9D9D9D]">Name</p>
              <p>{Referrer?.Bank?.AccountName}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-[#9D9D9D]">Amount</p>
              <p>{Referrer?.Bank?.CurrencySymbol + " " + priceSplitter(amountWithdrawable)}</p>
            </div>
            <div className="flex justify-center">
              <button
                className="btn btn-success"
                onClick={() => {
                  setConfirmRequest(false);
                  RequestEarningsPayment();
                }}
              >
                Submit Request
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div className="flex flex-col">
        <div className="p-4 flex flex-col lg:flex-row xl:flex-row justify-between items-center lg:items-start xl:items-start gap-4">
          <div className="relative flex-shrink-0">
            <img
              src={
                User && User.ProfileImage.length > 2
                  ? User?.ProfileImage
                  : "../../images/Avatarimage.jfif"
              }
              alt="User Profile"
              className="rounded-full w-10 h-10"
            />
            <span className="absolute bottom-0 right-0 transform translate-x-1/2 translate-y-1/2">
              <img
                src={
                  User && (User.UserStatus === "Employee" || User?.UserStatus === "Admin")
                    ? "../../images/badge.png"
                    : "../../images/userbadge.png"
                }
                alt="badge"
                className="w-6 h-6"
              />
            </span>
          </div>
          <div className="flex flex-col ml-4">
            <h1 className="text-2xl font-bold">
              {User?.firstname + " " + User?.lastname}
            </h1>
            <p className="text-sm text-gray-600 mt-2 lg:mt-0 xl:mt-0">
              Manage your referral account here
            </p>
          </div>

          {/* </div> */}

          <div className="flex flex-col items-start flex-1">
            <div className="text-xl font-semibold mr-4">Earnings</div>
            <div className="flex gap-4 items-start">
              <p className={`text-2xl font-bold ${isBlurred ? "blur-sm" : ""}`}>
              €{Earnings}
              </p>
              <button className="focus:outline-none" onClick={toggleBlur}>
                <img src="../../images/eye-disable.png" alt="eye-disable" />
              </button>
            </div>
          </div>

          <div className="flex items-start flex-1">
            <div className="relative flex-1 mb-4 sm:mb-0">
              <input
                type="text"
                className="border rounded-full pl-10 pr-4 py-2 w-full max-w-xs focus:outline-none focus:ring-2 focus:ring-green-400"
                placeholder="Search"
              />
              <span className="absolute left-4 top-1/2 transform -translate-y-1/2">
                <FiSearch />
              </span>
            </div>
            <div className="relative inline-block" onClick={() => modalOpen()}>
              <button
                className="ml-4 mb-4 sm:mb-0 sm:ml-4"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <BsQuestionCircle />
              </button>
              <span
                className={`absolute left-1/2 transform -translate-x-1/2 translate-y-2 bg-gray-700 text-white text-xs rounded px-2 py-1 ${
                  isHovered ? "showtooltip" : "hidetooltip"
                }`}
              >
                How we calculate your earnings
              </span>
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            className={`p-2 ${
              showReferrals ? "bg-green-100 text-green-600" : ""
            } rounded-md mr-2`}
            onClick={Referrals}
          >
            Referrals
          </button>
          <button
            className={`p-2 ${
              showAccountDetails ? "bg-green-100 text-green-600" : ""
            } rounded-md mr-2`}
            onClick={AccountDetails}
          >
            Account Details
          </button>
          <button
            className={`p-2 ${
              showWithdrawal ? "bg-green-100 text-green-600" : ""
            } rounded-md mr-2`}
            onClick={Withdrawal}
          >
            Withdrawal
          </button>
        </div>

        {showReferrals && (
          <div className="p-6">
            <div className="mb-8">
              <h2 className="text-xl font-semibold">Refer a friend</h2>
              <hr />
              <div className="mt-4 flex flex-col gap-3 lg:flex-row xl:flex-row items-center justify-between">
                <h3 className="text-lg font-semibold">Invite link</h3>
                <div className="flex items-center space-x-2 w-full lg:w-[35%] xl:w-[35%]">
                  <div className="flex items-center flex-1">
                    <input
                      type="text"
                      value={`academy.doyenify.com/signup?invite=${User?.ReferralId}`}
                      readOnly
                      className="flex-1 p-2 border rounded-lg border-[#D2D2D2] mr-2"
                    />
                    <button
                      className="p-2 rounded-md bg-gray-100"
                      onClick={handleCopy}
                    >
                      <FiCopy />
                    </button>
                  </div>
                  {copied && <span className="text-green-600">Copied!</span>}
                </div>

                <div className="flex items-center">
                  {isVisible && (
                    <div className="py-4 px-3 shadow-md bg-white border rounded-xl border-[#D2D2D2] flex flex-col items-start">
                      <span className="font-semibold pb-3">Share Link Via</span>
                      <div
                        style={{ textAlign: "right" }}
                        className="share-link"
                      >
                        <FacebookShareButton
                          url={`academy.doyenify.com/signup?invite=${User?.ReferralId}`}
                          quote="Use this invite link to signup with Doyenify Academy"
                          title="Invite Link"
                          hashtag="#DoyenifyAcademyBlogs"
                        >
                          <div
                            style={{
                              backgroundColor: "#3b5998",
                              borderRadius: "10px",
                              paddingLeft: "7px",
                              paddingRight: "7px",
                              paddingTop: "3px",
                              paddingBottom: "3px",
                              marginRight: "5px",
                            }}
                          >
                            <FacebookIcon size={32} round />
                          </div>
                        </FacebookShareButton>

                        <LinkedinShareButton
                          url={`academy.doyenify.com/signup?invite=${User?.ReferralId}`}
                          title="Use this invite link to signup with Doyenify Academy"
                        >
                          <div
                            style={{
                              backgroundColor: "#0072b1",
                              borderRadius: "10px",
                              paddingLeft: "7px",
                              paddingRight: "7px",
                              paddingTop: "3px",
                              paddingBottom: "3px",
                              marginRight: "5px",
                            }}
                          >
                            <LinkedinIcon size={32} round />
                          </div>
                        </LinkedinShareButton>

                        <WhatsappShareButton
                          url={`academy.doyenify.com/signup?invite=${User?.ReferralId}`}
                          title="Use this invite link to signup with Doyenify Academy"
                          separator=":: "
                        >
                          <div
                            style={{
                              backgroundColor: "#075e54",
                              borderRadius: "10px",
                              paddingLeft: "7px",
                              paddingRight: "7px",
                              paddingTop: "3px",
                              paddingBottom: "3px",
                              marginRight: "5px",
                            }}
                          >
                            <WhatsappIcon size={32} round />
                          </div>
                        </WhatsappShareButton>

                        <TwitterShareButton
                          url={`academy.doyenify.com/signup?invite=${User?.ReferralId}`}
                          title="Use this invite link to signup with Doyenify Academy"
                        >
                          <div
                            style={{
                              backgroundColor: "#00acee",
                              borderRadius: "10px",
                              paddingLeft: "7px",
                              paddingRight: "7px",
                              paddingTop: "3px",
                              paddingBottom: "3px",
                              marginRight: "5px",
                            }}
                          >
                            <TwitterIcon size={32} round />
                          </div>
                        </TwitterShareButton>
                      </div>
                    </div>
                  )}
                  <button
                    className="ml-2 p-2 border rounded-xl border-[#D2D2D2] flex items-center"
                    onClick={toggleVisibility}
                  >
                    <FiShare2 className="mr-2" /> Share
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <div className="mb-8 flex flex-col lg:flex-row xl:flex-row gap-3 justify-between items-center">
              <h2 className="text-lg font-semibold">Email invites</h2>
              <div className="mt-4 relative">
                <div className="flex items-center space-x-2 w-full">
                  <div className="space-y-2 flex-1">
                    {inputs.map((input, index) => (
                      <div key={input.id} className="flex">
                        <div className="flex flex-col gap-2 items-center w-full">
                          <input
                            type="email"
                            placeholder="Enter Email"
                            className="flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                            value={input.value}
                            onChange={(e) =>
                              handleInputChange(input.id, e.target.value)
                            }
                          />
                          {error && <p className="errortext">{error}</p>}
                        </div>
                        {index !== inputs.length - 1 && (
                          <button
                            className="p-2 rounded-md"
                            onClick={() => removeInputField(input.id)}
                          >
                            <FiMinusCircle />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                  <button
                    className="absolute -right-12 bottom-0"
                    onClick={addInputField}
                  >
                    <img
                      src="../../images/plus.png"
                      alt="add-more"
                      className="w-10 h-10"
                    />
                  </button>
                </div>
              </div>
              <button
                onClick={sendEmail}
                className="mt-4 p-2 flex items-center border rounded-xl border-[#D2D2D2]"
              >
                <FiSend className="mr-2" /> Send invites
              </button>
            </div>
            <hr />
            <div>
              <h2 className="text-lg font-semibold">Referrals</h2>
              <hr />
              <div className="mt-4 space-y-4">
                {Referrer ? (
                  <>
                    {Referrer?.Referrals.map((Referral: Referrals) => {
                      let status_color = "text-blue-500";
                      let earnings_color = "text-red-500";
                      let status_image = "../../images/registered.png";
                      let earnings_image = "../../images/no-earnings.png";
                      if (Referral.EarningsLabel === "Paid") {
                        status_color = "text-orange-500";
                        status_image = "../../images/converted.png";
                      }
                      if (Referral.ReferralStatus === "Converted") {
                        earnings_color = "text-green-500";
                        earnings_image = "../../images/paid.png";
                      }
                      return (
                        <div>
                          <ReferralItem
                            name={Referral.Name}
                            date={new Date(Referral.DateSignedUp).toDateString()}
                            status={Referral.ReferralStatus}
                            statusColor={status_color}
                            EarningsLabel={Referral.EarningsLabel}
                            earningsColor={earnings_color}
                            statusImage={status_image}
                            earningsImage={earnings_image}
                          />
                          <hr />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>No referrals yet.</>
                )}
              </div>
            </div>
          </div>
        )}
        {showAccountDetails && (
          <div className="p-6">
            <form onSubmit={handleSubmit1(submitData)}>
              <div className="mb-8">
                <h2 className="text-xl font-semibold">Bank Details</h2>
                <hr />
                <div className="mt-4 flex flex-col lg:flex-row xl:flex-row items-center lg:w-[75%] xl:w-[75%] justify-between">
                  <h3 className="text-lg font-semibold">Currency</h3>
                  <div className="border rounded-xl w-full lg:w-[40%] xl:w-[40%] border-[#D2D2D2] flex items-center">
                    <select
                      name="referrerCurrency"
                      id="referrerCurrency"
                      className="border rounded-xl flex-1 border-[#D2D2D2] flex items-center p-2"
                      value={ReferrerCurrency}
                      onChange={(e) => {
                        setReferrerCurrency(e.target.value);
                      }}
                    >
                      <option value="NGN"># Nigerian Naira</option>
                      <option value="EUR">€ Euros</option>
                      <option value="USD">$ US Dollars</option>
                      <option value="GBP">£ Pounds</option>
                    </select>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-4 flex flex-col w-full lg:flex-row xl:flex-row  items-center justify-between lg:w-[75%] xl:w-[75%]">
                <h2 className="text-lg font-semibold">Account Details</h2>
                <div className="flex flex-col w-full lg:w-[40%] xl:w-[40%] gap-4">
                  <div>
                    <input
                      type="text"
                      placeholder="Account Name"
                      className={
                        accountErrors.fullName
                          ? "form-control is-invalid"
                          : "flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                      }
                      value={fullName}
                      {...saveAccountDetails("fullName")}
                      onChange={(e) => {
                        setfullName(e.target.value);
                        checkIfNotEmpty();
                      }}
                    />
                    {accountErrors.fullName && (
                      <p className="errortext">{accountErrors.fullName.message}</p>
                    )}
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Bank Name"
                      className={
                        accountErrors.bankName
                          ? "form-control is-invalid"
                          : "flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                      }
                      value={bankName}
                      {...saveAccountDetails("bankName")}
                      onChange={(e) => {
                        setBankName(e.target.value);
                        checkIfNotEmpty();
                      }}
                    />
                    {accountErrors.bankName && (
                      <p className="errortext">{accountErrors.bankName.message}</p>
                    )}
                  </div>
                  {(ReferrerCurrency === 'USD' || ReferrerCurrency === 'GBP' || ReferrerCurrency === 'NGN') && <div>
                    <input
                      type="text"
                      placeholder="Account Number"
                      className={
                        accountErrors.accountNumber
                          ? "form-control is-invalid"
                          : "flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                      }
                      value={accountNumber}
                      {...saveAccountDetails("accountNumber")}
                      onChange={(e) => {
                        setAccountNumber(e.target.value);
                        checkIfNotEmpty();
                      }}
                    />
                    {accountErrors.accountNumber && (
                      <p className="errortext">
                        {accountErrors.accountNumber.message}
                      </p>
                    )}
                  </div>}
                  
              {(ReferrerCurrency === 'EUR') && <div>
                    <input
                      type="text"
                      placeholder="BIC"
                      className={
                        accountErrors.BIC
                          ? "form-control is-invalid"
                          : "flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                      }
                      value={BIC}
                      {...saveAccountDetails("BIC")}
                      onChange={(e) => {
                        setBIC(e.target.value);
                        checkIfNotEmpty();
                      }}
                    />
                    {accountErrors.BIC && (
                      <p className="errortext">
                        {accountErrors.BIC.message}
                      </p>
                    )}
                  </div>}
                  {(ReferrerCurrency === 'EUR' || ReferrerCurrency === 'GBP') && <div>
                    <input
                      type="text"
                      placeholder="IBAN"
                      className={
                        accountErrors.IBAN
                          ? "form-control is-invalid"
                          : "flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                      }
                      value={IBAN}
                      {...saveAccountDetails("IBAN")}
                      onChange={(e) => {
                        setIBAN(e.target.value);
                        checkIfNotEmpty();
                      }}
                    />
                    {accountErrors.IBAN && (
                      <p className="errortext">
                        {accountErrors.IBAN.message}
                      </p>
                    )}
                  </div>}
                  {(ReferrerCurrency === 'USD') && <div>
                    <input
                      type="text"
                      placeholder="Account Type"
                      className={
                        accountErrors.accountType
                          ? "form-control is-invalid"
                          : "flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                      }
                      value={accountType}
                      {...saveAccountDetails("accountType")}
                      onChange={(e) => {
                        setAccountType(e.target.value);
                        checkIfNotEmpty();
                      }}
                    />
                    {accountErrors.accountType && (
                      <p className="errortext">
                        {accountErrors.accountType.message}
                      </p>
                    )}
                  </div>}
                  {(ReferrerCurrency === 'USD') && <div>
                    <input
                      type="text"
                      placeholder="Routing Number"
                      className={
                        accountErrors.routingNumber
                          ? "form-control is-invalid"
                          : "flex-1 p-2 border rounded-lg border-[#D2D2D2] w-full"
                      }
                      value={routingNumber}
                      {...saveAccountDetails("routingNumber")}
                      onChange={(e) => {
                        setRoutingNumber(e.target.value);
                        checkIfNotEmpty();
                      }}
                    />
                    {accountErrors.routingNumber && (
                      <p className="errortext">
                        {accountErrors.routingNumber.message}
                      </p>
                    )}
                  </div>}

                </div>
              </div>
                  
              <hr />
              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={disabled}
                  className={
                    disabled
                      ? "bg-[#B5E3BA] border rounded-lg text-white p-2"
                      : "btn btn-success"
                  }
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        )}
        {showWithdrawal && (
          <div className="p-6">
            <div className="mb-4">
              <h2 className="text-xl font-semibold">Withdrawal Details</h2>
              <hr />
              <div className="mt-4 flex flex-col lg:flex-row xl:flex-row items-center justify-between">
                <h3 className="text-base font-medium">Amount withdrawable</h3>
                <div className="text-[#367E3E] font-medium text-lg flex items-center">
                 {Referrer?.Bank ? <label htmlFor="currency">{Referrer?.Bank?.CurrencySymbol + " " + priceSplitter(amountWithdrawable)}</label> :<label className="flash">Input bank details</label> } 
                </div>
                <button
                  disabled={threshholdReached()}
                  onClick={() => {
                    setConfirmRequest(true);
                  }}
                  className={
                    threshholdReached()
                      ? "bg-[#B5E3BA] border rounded-lg text-white p-2"
                      : "bg-[#367E3E] text-white px-4 py-2 rounded-lg"
                  }
                >
                  Request payment
                </button>
              </div>
            </div>
            <hr />
            <div className="mb-4">
              <h2 className="text-xl font-semibold">Transaction History</h2>
              <hr />
              {transactions && transactions.map((transaction:Transactions)=>{
                let showTicket = true;
                let disableTicket = true;
                if(transaction?.PaymentStatus === "Processed"){showTicket = false}
                else{
                  disableTicket = enableTicketOrNot(transaction.InitiatedTime);
                }
                return(
                  <div className="mt-4 flex flex-col lg:flex-row xl:flex-row justify-between items-center">
                  <div className="flex items-start gap-4">
                    <img
                      src="../../images/arrowup.png"
                      alt="arrow-up"
                      className="w-12 h-12"
                    />
                    <div className="flex flex-col">
                      <div className="flex">
                        <h2 className="text-lg font-semibold">
                          Transfer to {Referrer?.Bank?.AccountName}
                        </h2>
                        <p className="text-lg font-semibold ml-4">{Referrer?.Bank?.CurrencySymbol + " "+ priceSplitter(transaction.Amount)}</p>
                      </div>
                      <div className="flex justify-between items-start">
                        <p className="text-[#9D9D9D]">{transaction?.InitiatedTime}</p>
                        {transaction?.PaymentStatus === "Pending" ? 
                        <p className="text-[#C8C00C] bg-[#FEFFE0] px-2 py-1 rounded-md ml-4">
                        {transaction?.PaymentStatus}
                        </p> : transaction.PaymentStatus === "Processed" ?
                        <p className="text-[#367E3E] bg-[#FEFFE0] px-2 py-1 rounded-md ml-4">
                        {transaction?.PaymentStatus}
                        </p> : transaction.PaymentStatus === "Failed" ?
                        <p className="text-red-500 bg-[#FEFFE0] px-2 py-1 rounded-md ml-4">
                        {transaction?.PaymentStatus}
                        </p> : <p className="text-[#C8C00C] bg-[#FEFFE0] px-2 py-1 rounded-md ml-4">
                        {transaction?.PaymentStatus}
                        </p>
                      }
                      </div>
                    </div>
                  </div>
                  {showTicket && <div className="flex justify-end">
                    <button
                      disabled={disableTicket}
                      onClick={() => {
                        const particularTransaction = transactions.filter((transact:Transactions)=>transact.InitiatedTime === transaction.InitiatedTime)
                        setTransactionId(particularTransaction[0]?.TransactionId);
                        setTicket(true);
                      }}
                      className={
                        disableTicket
                          ? "bg-[#B5E3BA] border rounded-lg text-white p-2"
                          : "bg-[#367E3E] text-white p-2 rounded-lg"
                      }
                    >
                      Open Ticket
                    </button>
                  </div>}
                </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </Overlay>
  );
};

export default ReferralPage;
